import { getSellerSubmissionPublicFieldLabels } from "../../../utils/sellerIntake/sellerIntakeDefaults";
import { SELLER_CURRENCY_OPTIONS } from "./sellerIntakeFormConstants";
import { SellerFieldError, sellerFieldDescribedBy, sellerFieldInvalid, sellerIntakeFieldFocusHandler } from "./sellerIntakeFormFieldUtils";
import { useSellerIntakeCopy } from "../../../intl/productFormCopy.js";

const labels = getSellerSubmissionPublicFieldLabels();

function RequiredMark() {
  return (
    <span className="sell-car-form__required" aria-hidden="true">
      *
    </span>
  );
}

/**
 * @param {{
 *   input: import('../../../utils/sellerIntake/sellerIntakeTypes').SellerSubmissionInput,
 *   onChange: (patch: Partial<import('../../../utils/sellerIntake/sellerIntakeTypes').SellerSubmissionInput>) => void,
 *   errors?: Record<string, string|null|undefined>,
 *   disabled?: boolean,
 * }} props
 */
export default function SellerPricingFields({ input, onChange, errors = {}, disabled = false }) {
  const copy = useSellerIntakeCopy();
  return (
    <fieldset className="sell-car-form__section-card" disabled={disabled}>
      <legend className="sell-car-form__section-title">{copy.pricingSectionTitle}</legend>
      <p className="sell-car-form__section-helper">
        Ciudad y departamento se indican arriba en tus datos de contacto.
      </p>

      <div className="sell-car-form__grid">
        <div className="sell-car-form__field">
          <label htmlFor="seller-intake-asking-price">
            {labels.askingPrice} <RequiredMark />
          </label>
          <input
            id="seller-intake-asking-price"
            name="askingPrice"
            type="number"
            inputMode="numeric"
            min={0}
            enterKeyHint="next"
            value={input.askingPrice ?? ""}
            aria-invalid={sellerFieldInvalid("askingPrice", errors)}
            aria-describedby={sellerFieldDescribedBy("askingPrice", errors)}
            onChange={(event) => onChange({ askingPrice: event.target.value })}
            onFocus={sellerIntakeFieldFocusHandler}
          />
          <SellerFieldError fieldKey="askingPrice" message={errors.askingPrice} />
        </div>

        <div className="sell-car-form__field">
          <label htmlFor="seller-intake-currency">{labels.currency}</label>
          <select
            id="seller-intake-currency"
            name="currency"
            value={input.currency}
            aria-invalid={sellerFieldInvalid("currency", errors)}
            aria-describedby={sellerFieldDescribedBy("currency", errors)}
            onChange={(event) => onChange({ currency: event.target.value })}
            onFocus={sellerIntakeFieldFocusHandler}
          >
            {SELLER_CURRENCY_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <SellerFieldError fieldKey="currency" message={errors.currency} />
        </div>
      </div>
    </fieldset>
  );
}
